import Icon from "./icon-base";
import {
	directionSmall as directionSmallMarker,
	end as endMarker,
	hardStop as hardStopMarker,
	rotateMarker,
	softStop as softStopMarker,
	start as startMarker
} from "@/data/map-markers";

export default {
	name: "KTrucksMapHistoryIcon",

	mixins: [ Icon ],

	computed: {
		marker() {
			if ( this.isFirst ) {
				return startMarker;
			}

			if ( this.isLast ) {
				return endMarker;
			}

			if ( this.item.speed ) {
				return rotateMarker( directionSmallMarker, this.item.direction );
			}

			const hardStopThreshold = 1 * 60 * 1000;

			if ( this.item.endDate && ( this.item.endDate - this.item.date ) > hardStopThreshold ) {
				return hardStopMarker;
			}

			return softStopMarker;
		}
	}
};
